module.exports = __webpack_public_path__ + "static/media/fireengine.1404dbed.png";